// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";

// Afidium
import { RuptureComponent } from './rupture.component';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
    imports: [
        CommonModule,
        FontAwesomeModule,
    ],
    exports: [RuptureComponent],
    declarations: [RuptureComponent],
})
export class RuptureModule {}

